import axios from 'axios'

// Default instance calling stapyt api

export let instance = axios.create({
  baseURL: window.env.STAMPYT_API_HOST,
  timeout: 60000
})

instance.defaults.headers.common['x-api-key'] = window.env.STAMPYT_API_KEY
instance.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

instance.interceptors.response.use(
  res => {
    return res
  },
  err => {
    if (axios.isCancel(err)) {
      return { status: 100 }
    }
    if (err.code === 'ECONNABORTED') {
      return { status: 500 }
    } else {
      return err.response
    }
  }
)

export function tokenInterceptor(keycloak) {
  instance.interceptors.request.use(
    config => {
      const token = keycloak.token
      config.headers.Authorization = `Bearer ${token}`
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

// Instance of stampotheque V2
export let instanceStampotheque = axios.create({
  baseURL: window.env.STAMPOTHEQUE_API_HOST,
  timeout: 60000
})

instanceStampotheque.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

// Instance of Coveryt
export let instanceCoveryt = axios.create({
  baseURL: window.env.STAMPYT_DEVELOPER_HOST,
  timeout: 60000
})

// TODO: need to be change and refactor.
instanceCoveryt.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
instanceCoveryt.defaults.headers.common['Authorization'] = window.env.STAMPYT_DEVELOPER_COVERYT_API_KEY
// instanceCoveryt.defaults.headers.common['x-api-key'] = window.env.STAMPYT_DEVELOPER_COVERYT_API_KEY

// Instance of Falyt
export let instanceFalyt = axios.create({
  baseURL: window.env.STAMPYT_DEVELOPER_HOST,
  timeout: 60000
})

instanceFalyt.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
instanceFalyt.defaults.headers.common['Authorization'] = window.env.STAMPYT_DEVELOPER_FALYT_API_KEY
// instanceFalyt.defaults.headers.common['x-api-key'] = window.env.STAMPYT_DEVELOPER_FALYT_API_KEY

// Instance of ClippingPath (SAAS Détourage)
export let instanceClippingPath = axios.create({
  baseURL: window.env.STAMPYT_CLIPPINGPATH_HOST,
  timeout: 60000,
  auth: {
    username: window.env.STAMPYT_CLIPPINGPATH_USER,
    password: window.env.STAMPYT_CLIPPINGPATH_PASSWORD
  }
})
